(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vawcroft-custom-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vaw-custom-product')) {
  customElements.define('vaw-custom-product', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.moveWoodGroups();
      this.mountWoodChoices();
      this.previewStage = this.querySelector('[data-preview-stage]');
      this.defaultPreview = this.previewStage?.cloneNode(true);
      this.addEventListener('change', () => this.update());
      this.addEventListener('input', () => this.updateSummary());
      this.addEventListener('click', event => {
        const clear = event.target.closest('[data-clear-choice]');
        if (!clear) return;
        for (const input of clear.closest('[data-choice-group]').querySelectorAll('input[type="radio"]')) input.checked = false;
        this.update();
      });
      this.form.addEventListener('submit', event => this.validate(event));
      this.update();
      this.woodObserver = new MutationObserver(records => {
        const relevant = records.some(record => [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.matches('template[data-wood-choice], [data-wood-choices]') || node.querySelector('template[data-wood-choice], [data-wood-choices]'))));
        if (relevant) { this.mountWoodChoices(); this.update(); }
      });
      this.woodObserver.observe(this, {childList: true, subtree: true});
    }
    disconnectedCallback() {
      this.woodObserver?.disconnect();
    }
    moveWoodGroups() {
      const woodSection = this.querySelector('[data-wood-section]');
      const woodFields = woodSection?.querySelector('[data-wood-fields]');
      if (!woodFields) return;
      for (const role of ['base', 'inlay', 'second_inlay']) {
        const group = this.querySelector('[data-choice-group="' + role + '"]');
        const wrapper = group?.closest('.vaw-cp__full');
        if (wrapper && wrapper.parentElement !== woodFields) woodFields.append(wrapper);
      }
      woodSection.hidden = !woodFields.children.length;
    }
    mountWoodChoices() {
      const sources = [...this.querySelectorAll('template[data-wood-choice]')];
      for (const holder of this.querySelectorAll('[data-wood-choices]')) {
        const previousKey = holder.querySelector('input:checked')?.dataset.key;
        const mounted = holder.dataset.woodMounted === 'true';
        const group = holder.closest('[data-choice-group]');
        const otherChecked = group?.querySelector('input:checked');
        const fragment = document.createDocumentFragment();
        for (const template of sources) {
          if (template.dataset.woodChoice !== holder.dataset.woodRole) continue;
          const clone = template.content.cloneNode(true);
          const input = clone.querySelector('input[type="radio"]');
          const label = clone.querySelector('label');
          if (!input || !label) continue;
          const choiceId = input.id + '-' + holder.dataset.woodGroup;
          input.id = choiceId;
          label.htmlFor = choiceId;
          input.name = 'contact[' + holder.dataset.woodField + ']';
          input.required = holder.dataset.woodRequired === 'true';
          input.checked = !input.disabled && (previousKey ? input.dataset.key === previousKey : !mounted && !otherChecked && input.dataset.key === holder.dataset.woodDefault);
          fragment.append(clone);
        }
        holder.replaceChildren(fragment);
        holder.dataset.woodMounted = 'true';
      }
    }
    selected(key) {
      return this.querySelector('input[data-option="' + key + '"]:checked');
    }
    toggleCustom(groupSelector, inputSelector, show) {
      const group = this.querySelector(groupSelector);
      const input = this.querySelector(inputSelector);
      if (!group || !input) return;
      group.hidden = !show;
      input.disabled = !show;
      input.required = show;
    }
    update() {
      this.toggleCustom('[data-other-size]', '[data-custom-size]', this.selected('size')?.dataset.customSizeChoice === 'true');
      this.toggleCustom('[data-other-thickness]', '[data-custom-thickness]', this.selected('thickness')?.dataset.behavior === 'custom_thickness');
      for (const input of this.querySelectorAll('input[data-option]')) {
        if (input.dataset.editorDisabled === 'true') { input.disabled = true; input.checked = false; }
      }
      const base = this.selected('base');
      const baseKey = base?.dataset.behavior === 'wood' ? base.dataset.key : null;
      for (const input of this.querySelectorAll('input[data-option="inlay"]')) {
        input.disabled = input.dataset.editorDisabled === 'true' || (input.dataset.behavior === 'wood' && !!baseKey && input.dataset.key === baseKey);
        if (input.disabled && input.checked) input.checked = false;
      }
      const primary = this.selected('inlay');
      const primaryKey = primary?.dataset.behavior === 'wood' ? primary.dataset.key : null;
      let duplicate = false;
      for (const input of this.querySelectorAll('input[data-option="second_inlay"]')) {
        input.disabled = input.dataset.editorDisabled === 'true' || (input.dataset.behavior === 'wood' && ((!!baseKey && input.dataset.key === baseKey) || (!!primaryKey && input.dataset.key === primaryKey)));
        if (input.disabled && input.checked) { input.checked = false; duplicate = true; }
      }
      if (duplicate) {
        const none = this.querySelector('input[data-option="second_inlay"][data-behavior="one_inlay"]:not(:disabled)');
        if (none) none.checked = true;
      }
      this.updateSummary();
      this.updatePreview();
      this.updateStartingPrice();
    }
    getBasePriceCents() {
      const selectedPrice = Number(this.selected('size')?.dataset.variantPriceCents);
      const defaultPrice = Number(this.dataset.startingPriceCents) || 0;
      return Number.isFinite(selectedPrice) && selectedPrice > 0 ? selectedPrice : defaultPrice;
    }
    getAdditionsCents() {
      let additions = 0;
      for (const input of this.querySelectorAll('input[data-option]:checked:not(:disabled)')) {
        if (['base', 'inlay', 'second_inlay'].includes(input.dataset.option)) continue;
        additions += Math.max(0, Number(input.dataset.extraCents) || 0);
      }
      const base = this.selected('base');
      if (base && !base.disabled && base.dataset.behavior === 'wood' && base.dataset.key !== 'hard_maple') {
        additions += Math.ceil((this.getBasePriceCents() * 0.10) / 500) * 500;
      }
      const secondInlay = this.selected('second_inlay');
      if (secondInlay && !secondInlay.disabled && secondInlay.dataset.behavior === 'wood') {
        additions += 2000;
      }
      return additions;
    }
    updateStartingPrice() {
      const output = this.querySelector('[data-starting-price-amount]');
      if (!output) return;
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: this.dataset.currency || 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      });
      output.textContent = money.format((this.getBasePriceCents() + this.getAdditionsCents()) / 100);
    }
    updateSummary() {
      const output = this.querySelector('[data-extra-summary]');
      if (!output) return;
      const perBoard = this.getAdditionsCents();
      const configuration = this.querySelector('[data-configuration-summary]');
      if (configuration) configuration.value = [...this.querySelectorAll('[data-choice-group]')].map(group => {
        const selected = group.querySelector('input:checked:not(:disabled)');
        return selected ? group.dataset.groupLabel + ': ' + selected.value : '';
      }).filter(Boolean).join('\n');
      const count = Math.max(1, Number(this.querySelector('[data-board-quantity]')?.value || 1));
      const additions = this.querySelector('[data-quoted-additions]');
      if (!perBoard) {
        output.textContent = this.dataset.noExtras;
        if (additions) additions.value = output.textContent;
        return;
      }
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:this.dataset.currency || 'USD'});
      output.textContent = this.dataset.extraTemplate.replace('[amount]', money.format(perBoard / 100)).replace('[total]', money.format(perBoard * count / 100));
      if (additions) additions.value = output.textContent;
    }
    updatePreview() {
      if (!this.previewStage || !this.defaultPreview) return;
      const selected = Object.fromEntries([...this.querySelectorAll('input[data-option]:checked:not(:disabled)')].map(input => [input.dataset.option, input.dataset.key]));
      let best = null;
      let score = -1;
      for (const candidate of this.querySelectorAll('template[data-config-preview]')) {
        let matches = true;
        let specificity = 0;
        for (const attribute of candidate.attributes) {
          if (!attribute.name.startsWith('data-match-') || !attribute.value) continue;
          const key = attribute.name.slice(11).replaceAll('-', '_');
          specificity++;
          if (selected[key] !== attribute.value) { matches = false; break; }
        }
        if (matches && specificity > score) { best = candidate; score = specificity; }
      }
      const previewKey = best?.dataset.configPreview || 'default';
      if (this.currentPreview === previewKey) return;
      this.currentPreview = previewKey;
      this.previewStage.replaceChildren(...(best ? best.content.cloneNode(true).childNodes : this.defaultPreview.cloneNode(true).childNodes));
    }
    validate(event) {
      this.update();
      const description = this.querySelector('[data-design]');
      const reference = this.querySelector('[data-reference]');
      const error = this.querySelector('[data-form-error]');
      const missing = [...this.querySelectorAll('[data-choice-group][data-required="true"]')].find(group => !group.querySelector('input:checked:not(:disabled)'));
      if (missing) {
        event.preventDefault();
        if (error) { error.textContent = this.dataset.selectionError.replace('[group]', missing.dataset.groupLabel); error.hidden = false; }
        missing.focus();
        return;
      }
      if (!description?.value.trim() && !reference?.value.trim()) {
        event.preventDefault();
        if (error) { error.textContent = this.dataset.designError; error.hidden = false; }
        description?.focus();
        return;
      }
      if (error) error.hidden = true;
      if (!this.form.reportValidity()) { event.preventDefault(); return; }
      if (description && !description.value.trim() && reference?.value.trim()) description.value = this.dataset.referenceLabel + ' ' + reference.value.trim();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
